import React from 'react';
import { Filter, RefreshCw } from 'lucide-react';

const FilterControls = ({ filters, onFilterChange, activityCount, refreshing }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 mb-4">
        <Filter className="text-white" size={20} />
        <h3 className="text-white font-semibold text-lg">Filter Activities</h3>
        {refreshing && (
          <RefreshCw className="text-white/60 animate-spin" size={16} />
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Action Type Filter */}
        <div>
          <label className="block text-white/80 text-sm font-medium mb-2">
            Action Type
          </label>
          <select
            value={filters?.actionType}
            onChange={(e) => onFilterChange('actionType', e?.target?.value)}
            className="w-full px-4 py-2 bg-white/10 text-white rounded-lg border border-white/20 focus:border-white/40 focus:outline-none transition-colors"
          >
            <option value="all" className="bg-[#32215d]">All Activities</option>
            <option value="song_addition" className="bg-[#32215d]">Song Additions</option>
            <option value="profile_update" className="bg-[#32215d]">Profile Updates</option>
            <option value="course_completion" className="bg-[#32215d]">Course Completions</option>
          </select>
        </div>

        {/* User Type Filter */}
        <div>
          <label className="block text-white/80 text-sm font-medium mb-2">
            User Type
          </label>
          <select
            value={filters?.userType}
            onChange={(e) => onFilterChange('userType', e?.target?.value)}
            className="w-full px-4 py-2 bg-white/10 text-white rounded-lg border border-white/20 focus:border-white/40 focus:outline-none transition-colors"
          >
            <option value="all" className="bg-[#32215d]">All Users</option>
            <option value="superuser" className="bg-[#32215d]">Superusers</option>
            <option value="editor" className="bg-[#32215d]">Editors</option>
            <option value="user" className="bg-[#32215d]">Students</option>
            <option value="talent" className="bg-[#32215d]">Talent</option>
          </select>
        </div>

        {/* Time Range Filter */}
        <div>
          <label className="block text-white/80 text-sm font-medium mb-2">
            Time Range
          </label>
          <select
            value={filters?.timeRange}
            onChange={(e) => onFilterChange('timeRange', Number(e?.target?.value))}
            className="w-full px-4 py-2 bg-white/10 text-white rounded-lg border border-white/20 focus:border-white/40 focus:outline-none transition-colors"
          >
            <option value={24} className="bg-[#32215d]">Last 24 Hours</option>
            <option value={168} className="bg-[#32215d]">Last 7 Days</option>
            <option value={720} className="bg-[#32215d]">Last 30 Days</option>
          </select>
        </div>
      </div>
      {/* Results Count */}
      <div className="flex items-center justify-between pt-4 border-t border-white/10">
        <p className="text-white/60 text-sm">
          Showing <span className="font-semibold text-white">{activityCount}</span> activities
        </p>
        <button
          onClick={() => onFilterChange('limit', filters?.limit === 50 ? 100 : 50)}
          className="text-white/80 hover:text-white text-sm font-medium transition-colors"
        >
          {filters?.limit === 50 ? 'Show More' : 'Show Less'}
        </button>
      </div>
    </div>
  );
};

export default FilterControls;